import * as React from 'react';
import { useEffect, useState } from 'react';
import { Container, Header, KeyValuePairs, Textarea } from '@amzn/awsui-components-react-v3';
import { getNotificationBatch, updateNotificationBatch } from 'src/api/notifications';
import { NotificationComments } from 'src/components/notifications/comment';
import { TABLE_CONTENT_TYPE } from 'src/commons/constants';
import { getPhoneToolLink } from 'src/commons/common';

export interface NotificationBatchDetailPageProps {
  setContentType: any;
  match: any;
  activeGroup: string;
  activeWorkspace: any;
  username: string;
}

export const NotificationBatchDetailPage = (props: NotificationBatchDetailPageProps) => {
  const [notificationBatch, setNotificationBatch] = useState({});

  useEffect(() => {
    props.setContentType(TABLE_CONTENT_TYPE);
    handleRefresh();
  }, [props.match.params.NotificationBatchId]);

  const handleRefresh = async () => {
    if (!props.activeGroup) return;
    const notification = await getNotificationBatch({
      NotificationBatchId: props.match.params.NotificationBatchId,
      NotificationOwnerId: props.activeWorkspace ? props.activeWorkspace.workspaceId : props.activeGroup,
    });
    setNotificationBatch(notification.NotificationBatch);
    await updateNotificationBatch({
      NotificationBatchId: notification.NotificationBatch.NotificationBatchId,
      MarkComment: false,
      NotificationOwnerId: props.activeWorkspace ? props.activeWorkspace.workspaceId : props.activeGroup,
    });
  };

  return (
    <>
      <Container header={<Header variant='h2'>{notificationBatch['Subject']}</Header>}>
        <Textarea value={notificationBatch['Content']} readOnly rows={10} />
      </Container>
      <br />
      <Container header={<Header variant={'h2'}>Details</Header>}>
        <KeyValuePairs
          columns={1}
          items={[{ label: 'Receiver list', value: notificationBatch['ReceiverIdList']?.join('; ') }].filter(
            (item) => item != undefined,
          )}
        />
        <KeyValuePairs
          columns={4}
          items={[
            {
              label: 'Sender',
              value: getPhoneToolLink(notificationBatch['SenderId']),
            },
            { label: 'Sender group or workspace', value: notificationBatch['NotificationOwnerId'] },
            { label: 'Priority', value: notificationBatch['PriorityLevel'] },
            { label: 'Email sent', value: notificationBatch['EmailSent'] ? 'Sent' : 'Not sent' },
            { label: 'Create time', value: new Date(notificationBatch['CreateTime']).toLocaleString() },
            { label: 'Last update time', value: new Date(notificationBatch['LastCommentTime']).toLocaleString() },
          ].filter((item) => item != undefined)}
        />
      </Container>
      {notificationBatch['NotificationBatchId'] && (
        <NotificationComments
          {...props}
          notificationBatchId={notificationBatch['NotificationBatchId']}
          notificationId=''
        />
      )}
    </>
  );
};
